/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createOwnedCard = /* GraphQL */ `
  mutation CreateOwnedCard(
    $input: CreateOwnedCardInput!
    $condition: ModelOwnedCardConditionInput
  ) {
    createOwnedCard(input: $input, condition: $condition) {
      id
      imageUrl
      year
      setName
      player
      cardNum
      condition
      graded
      qualifier
      gameUsed
      autograph
      sold
      serialNumber
      price
      soldPrice
      completeSetId
      label
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateOwnedCard = /* GraphQL */ `
  mutation UpdateOwnedCard(
    $input: UpdateOwnedCardInput!
    $condition: ModelOwnedCardConditionInput
  ) {
    updateOwnedCard(input: $input, condition: $condition) {
      id
      imageUrl
      year
      setName
      player
      cardNum
      condition
      graded
      qualifier
      gameUsed
      autograph
      sold
      serialNumber
      price
      soldPrice
      completeSetId
      label
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteOwnedCard = /* GraphQL */ `
  mutation DeleteOwnedCard(
    $input: DeleteOwnedCardInput!
    $condition: ModelOwnedCardConditionInput
  ) {
    deleteOwnedCard(input: $input, condition: $condition) {
      id
      imageUrl
      year
      setName
      player
      cardNum
      condition
      graded
      qualifier
      gameUsed
      autograph
      sold
      serialNumber
      price
      soldPrice
      completeSetId
      label
      createdAt
      updatedAt
      owner
    }
  }
`;
